import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ChevronsUpDown } from 'lucide-react';
import { useIsSmallScreen } from '@/components/ui/breakpoint';

export type NavigationItem = {
  value: string;
  label: string;
  disabled?: boolean;
};

type Props = {
  items: NavigationItem[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
};

export function TabsOrDropdown({ items, value, onChange, className }: Props) {
  const isSmallScreen = useIsSmallScreen();
  const activeItem = items.find((item) => item.value === value);

  if (isSmallScreen) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" role="combobox" className="flex !justify-between items-center">
            {activeItem?.label}
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-[--radix-dropdown-menu-trigger-width] rounded-lg"
          side="bottom"
          align="start"
          sideOffset={4}
        >
          {items.map((item) => (
            <DropdownMenuGroup key={item.value}>
              <DropdownMenuItem
                onSelect={() => onChange(item.value)}
                disabled={item.disabled}
                className={value === item.value ? 'bg-accent' : ''}
              >
                {item.label}
              </DropdownMenuItem>
            </DropdownMenuGroup>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <Tabs value={value} onValueChange={onChange}>
      <TabsList className={className}>
        {items.map((item) => (
          <TabsTrigger key={item.value} value={item.value} disabled={item.disabled}>
            {item.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
